export enum AppraiserFlagType {
    Retired = 1,
    Preferred = 2,
    Issue = 3,
    Blacklisted = 4,
}
